import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Homepage from './pages/homepage/homepage'
import './App.css'
import Navbar from './components/navbar/navbar'
import ManualTres from './pages/consultas/manual-tres/manual-tres'
//import AutoTres from './pages/consultas/auto-tres/auto-tres'
import Login from './pages/login/login'
import MyConsultas from './pages/usuarios/my-consults/my-consults'
import AllConsults from './pages/usuarios/all-consults/all-consults'
//import General from './pages/consultas/general/general'
//import Amor from './pages/consultas/amor/amor'
import ConsultsView from './pages/usuarios/consults-view/consults-view'
//import YesOrNo from './pages/consultas/yesorno/yesorno'
import ComoFunciona from './pages/como-funciona/como-funciona'
import About from './pages/about/about'
//import Footer from './components/footer/footer'
import Celta from './pages/consultas/celta/celta'
//import ManualYesOrNo from './pages/consultas/manual/yesorno/yesorno'
import Pregunta from './pages/consultas/pregunta/pregunta'
import Sino from './pages/consultas/sino/sino'
import Love from './pages/consultas/love/love'
import NewGeneral from './pages/consultas/gral/newGeneral'
import DosPreguntas from './pages/consultas/dos-preguntas/dos-preguntas'
import TresPreguntas from './pages/consultas/tres-preguntas/tres-preguntas'
import IchingPregunta from './pages/iching/pregunta/ichin-pregunta'
import Compatibilidad from './pages/consultas/compatibilidad/compatibilidad'
import Free from './pages/consultas/free/free'
import VidaPasada from './pages/consultas/vida-pasada/vida-pasada'
import Evolutivo from './pages/consultas/evolutivo/evolutivo'
import MejorAno from './pages/consultas/mejor/mejor'
import MejorAno10Dias from './pages/mejor-ano-10-dias/MejorAno10Dias'
import ConsultUsuarios from './pages/usuarios/consult-usuaios/consult-usuarios'
import AjustesFoto from './pages/usuarios/ajustes-foto/ajustes-foto'
import OneQuestion from './pages/consultas/manual/1-pregunta/1-pregunta'
import CuatroPreguntas from './pages/consultas/cuatro-preguntas/cuatro-preguntas'
import CincoPreguntas from './pages/consultas/cinco-preguntas/cinco-preguntas'
import Proteccion from './pages/consultas/proteccion/proteccion'
import Abundancia from './pages/consultas/abundancia/abundancia'
import Autoconocimiento from './pages/consultas/autoconocimiento/autoconocimiento'
import Atraccion from './pages/consultas/atraccion/atraccion'
import LoveLight from './pages/consultas/love-light/love-light'
import ExPareja from './pages/consultas/ex-pareja/ex-pareja'
import Renacer from './pages/consultas/renacer/renacer'
import CartaNatal from './pages/consultas/carta-natal/carta-natal'
import YoFuturo from './pages/consultas/yo-futuro/yo-futuro'
import Temporada from './pages/consultas/temporada/temporada'
import Interior from './pages/consultas/interior/interior'
import Bloqueo from './pages/consultas/bloqueo/bloqueo'
import Propio from './pages/consultas/propio/propio'
import Encrucijada from './pages/consultas/encrucijada/encrucijada'
import Guias from './pages/consultas/guias/guias'
import Romper from './pages/consultas/romper/romper'
import RenacerAlma from './pages/combos/renacer-alma/renacer-alma'
import AbundanciaConsciente from './pages/combos/abundancia-consciente/abundancia-consciente'
import AmorYMerecimiento from './pages/combos/amor-y-merecimiento/amor-y-merecimiento'
import ClaridadDireccion from './pages/combos/claridad-direccion/claridad-direccion'
import PropositoAlma from './pages/combos/proposito-alma/proposito-alma'
import SanacionProfunda from './pages/combos/sanacion-profunda/sanacion-profunda'
import FlexibleCombo from './pages/combos/flexible/flexible'
import Trabajo from './pages/consultas/trabajo/trabajo'
import Infidelidad from './pages/consultas/infidelidad/infidelidad'
import Futuro from './pages/consultas/futuro/futuro'

function App() {
    return (
        <div className="body-root">
            <Navbar />
            <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/manual/three" element={<ManualTres />} />
                <Route path="/auto/pregunta" element={<Pregunta />} />
                <Route path="/login" element={<Login />} />
                <Route path="/user/myconsults" element={<MyConsultas />} />
                <Route path="/user/allconsults" element={<AllConsults />} />
                <Route path="/general" element={<NewGeneral />} />
                <Route path="/auto/love" element={<Love />} />
                <Route path="/auto/celta" element={<Celta />} />
                <Route path="/user/consults-view/:id" element={<ConsultsView />} />
                <Route path="/auto/sino" element={<Sino />} />
                <Route path="/how-it-works" element={<ComoFunciona />} />
                <Route path="/about" element={<About />} />
                {/* <Route path="/manual/yon" element={<ManualYesOrNo />} /> */}
                <Route path="/auto/2-preguntas" element={<DosPreguntas />} />
                <Route path="/auto/3-preguntas" element={<TresPreguntas />} />
                <Route path="/iching/pregunta" element={<IchingPregunta />} />
                <Route path="/auto/compatibilidad" element={<Compatibilidad />} />
                <Route path="/auto/free" element={<Free />} />
                <Route path="/auto/vidapasada" element={<VidaPasada />} />
                <Route path="/auto/evolutivo" element={<Evolutivo />} />
                <Route path="/auto/mejor" element={<MejorAno />} />
                <Route path="/mejor" element={<MejorAno10Dias />} />
                <Route path="/user/usuarios" element={<ConsultUsuarios />} />
                <Route path="/user/ajustes-foto" element={<AjustesFoto />} />
                <Route path="/manual/pregunta" element={<OneQuestion />} />
                <Route path="/auto/4-preguntas" element={<CuatroPreguntas />} />
                <Route path="/auto/5-preguntas" element={<CincoPreguntas />} />
                <Route path="/auto/proteccion" element={<Proteccion />} />
                <Route path="/auto/abundancia" element={<Abundancia />} />
                <Route path="/auto/trabajo" element={<Trabajo />} />
                <Route path="/auto/infidelidad" element={<Infidelidad />} />
                <Route path="/auto/futuro" element={<Futuro />} />
                <Route path="/auto/autoconocimiento" element={<Autoconocimiento />} />
                <Route path="/auto/atraccion" element={<Atraccion />} />
                <Route path="/auto/love-light" element={<LoveLight />} />
                <Route path="/auto/ex-pareja" element={<ExPareja />} />
                <Route path="/auto/renacer" element={<Renacer />} />
                <Route path="/auto/carta-natal" element={<CartaNatal />} />
                <Route path="/auto/yo-futuro" element={<YoFuturo />} />
                <Route path="/auto/temporada" element={<Temporada />} />
                <Route path="/auto/interior" element={<Interior />} />
                <Route path="/auto/bloqueo" element={<Bloqueo />} />
                <Route path="/auto/propio" element={<Propio />} />
                <Route path="/auto/encrucijada" element={<Encrucijada />} />
                <Route path="/auto/guias" element={<Guias />} />
                <Route path="/auto/romper" element={<Romper />} />
                <Route path="/auto/combo" element={<FlexibleCombo />} />
                <Route path="/combo/renacer-alma" element={<RenacerAlma />} />
                <Route path="/combo/abundancia-consciente" element={<AbundanciaConsciente />} />
                <Route path="/combo/amor-y-merecimiento" element={<AmorYMerecimiento />} />
                <Route path="/combo/claridad-direccion" element={<ClaridadDireccion />} />
                <Route path="/combo/proposito-alma" element={<PropositoAlma />} />
                <Route path="/combo/sanacion-profunda" element={<SanacionProfunda />} />
            </Routes>
        </div>
    )
}

export default App
